<template>
  <v-list dense class="non-selectable master-list ">
    <v-list-tile class="py-3 height-auto height-auto-divChild">
      <v-list-tile-content>
        <div class="title mb-1">
          {{ User }}
        </div>
        <div v-if="profile.Tecnico" class="body-1">
          Técnico: {{ profile.TecnicoNombre }}
        </div>
        <div v-if="profile.Cliente" class="body-1">
          Cliente: {{ profile.ClienteNombre }}
        </div>
        <div v-if="profile.Cliente" class="body-1">
          Instalación: {{ profile.ClienteNombre }}
        </div>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider />
    <!-- <v-list-tile to="/">
      <v-list-tile-action>
        <v-icon>home</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Home
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider/> -->
    <v-list-tile to="/incidencias/" exact>
      <v-list-tile-action>
        <v-icon>mdi-clipboard-text</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Incidencias
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/estadisticas/tecnicos/">
      <v-list-tile-action>
        <v-icon>mdi-poll</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Estadísticas
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Ficheros maestros -->
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/clientes/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Clientes
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/areasDeTrabajo/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Areas de trabajo
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/departamentos/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Departamentos
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/prioridad/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Prioridad
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/programa/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Programas
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/sistemasOperativos/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Sistemas Operativos
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <!--<v-divider />
    <v-list-tile to="/situacionProyecto/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Situación de proyectos
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>-->
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/tipoIncidencia/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Tipo de incidencias
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/operario/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Operarios
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="isTecnico" />
    <v-list-tile v-if="isTecnico" to="/usuarios/">
      <v-list-tile-action>
        <v-icon>mdi-trello</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Usuarios
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Fin de los ficheros mestros-->
    <v-divider />
    <v-divider v-if-tecnico />
    <v-list-tile @click="darkTheme = !darkTheme">
      <v-list-tile-action>
        <v-switch v-model="darkTheme" @click.native.stop="() => {}" />
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          Dark Mode
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider />
    <v-list-tile @click="logout">
      <v-list-tile-action>
        <v-icon color="red">
          mdi-exit-to-app
        </v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          LogOut
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider />

    <v-divider class="to-bottom" />
    <v-list-tile class="py-2">
      <v-list-tile-action>
        <img alt="SopheoWeb" src="@/statics/icons/android-chrome-512x512.png" style="width:40px;">
      </v-list-tile-action>
      <v-list-tile-content class="text-xs-center">
        <v-list-tile-title class="text-xs-center">
          <a class="text-blue-9 link" href="/" target="_blank">
            {{ $config.AppName }}
          </a>
        </v-list-tile-title>
        <v-list-tile-sub-title>
          {{ $config.version }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider />
    <v-list-tile class="py-3">
      <v-list-tile-action>
        <img alt="Sime" src="@/statics/imglogo_Sime.png" style="width:35px;" class="shadow-3">
      </v-list-tile-action>
      <v-list-tile-content class="text-xs-center">
        <v-list-tile-title class="text-xs-center">
          <a class="text-blue-9 link" href="http://www.sime.es/" target="framename">
            Grupo SIME
          </a>
        </v-list-tile-title>
        <v-list-tile-sub-title>
          <a class="text-blue-9 link" href="tel:96 585 90 11">
            96 585 90 11
          </a>&nbsp;/
          <a class="text-blue-9 link" href="mailto:soporte@sime.es">
            soporte@sime.es
          </a>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  data () {
    return {
      profile: this.$store.getters['getProfile'],
      darkTheme: false,
      isTecnico: false,
      items: [
        { title: 'Prueba 1' },
        { title: 'Prueba 2' },
        { title: 'Prueba 3' },
        { title: 'Prueba 4' }
      ]
    }
  },
  computed: {
    User: function () {
      return window.capitalize(this.profile.User)
    }
  },
  watch: {
    darkTheme: function (value) {
      this.$vuetify.dark = value
      this.$store.dispatch('setDarkTheme', value)
    }
  },
  created () {
    this.darkTheme = this.$store.state.darkTheme
  },
  mounted () {
    this.getRol()
  },
  methods: {
    logout: function () {
      this.$store.dispatch('AUTH_LOGOUT')
    },
    getRol: function () {
      if (this.profile.Role === 'Tecnico') {
        this.isTecnico = true
      }
    }
  }
}
</script>

<style>
.master-list {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.master-list .to-bottom {
  margin-top: auto;
}
.link {
  color: inherit;
  font-size: inherit;
  font-weight: 500;
  text-decoration: none;
}
.link:hover {
  text-decoration: underline;
}
</style>
